document.addEventListener('turbolinks:load', () => {
  const $ = (window as any).jQuery;

  validateParticipantsCount();

  $('body').on('change', '.js-participants-count-check select', () => {
    validateParticipantsCount();
  })
});


// コンテナに data-max か data-fixed を設定すると、
// 中身の select 合計をチェックします。
//
// 例）
// .js-participants-count-check data-max=4 data-title=参加人数
// .js-participants-count-check data-fixed=2 data-title=大人
//
// OPTIONS
// onValid: 値が正しい時のコールバック関数

function validateParticipantsCount({ onValid }: { onValid?: () => void } = {}) {

  const countType = 'participants-count';

  const $ = (window as any).jQuery;
  const $containers = $(`.js-${countType}-check`);
  const $contentOnValid = $(`*[data-check="${countType}"][data-state="valid"]`);
  const $contentOnInvalid = $(`*[data-check="${countType}"][data-state="invalid"]`);

  function handleError($container, message: string) {
    // WORKAROUND
    // Bootstrap の .custom-select が設定されていると append されないので setTimeout を使用
    setTimeout(() => {
      $container.append(`
      <div class="alert alert-danger py-1 px-2 mt-1 small">
        ${message}
      </div>
    `);
    }, 100);
    $contentOnInvalid.show();
    $contentOnValid.hide();
  }

  function handleSuccess($container) {
    $container.find('.alert').remove();
    $contentOnInvalid.hide();
    $contentOnValid.show();
    if (typeof onValid === 'function') { onValid(); }
  }


  $containers.find('.alert').remove();
  $containers.each((i, container) => {
    let total = 0;

    const max     = parseInt($(container).attr('data-max'));
    const fixed   = parseInt($(container).attr('data-fixed'));
    const subject = $(container).attr('data-title');

    $(container).find('select').each((i, select) => {
      total += parseInt($(select).val());
    });

    if (max && total > max) {
      handleError($(container), `${subject}: ${max}`);
    } else {
      handleSuccess($(container));
    }

    if (fixed && total !== fixed) {
      handleError($(container), `${subject}: ${fixed}`);
    } else {
      handleSuccess($(container));
    }
  });

}